export var DialogPosition;
(function (DialogPosition) {
    DialogPosition[DialogPosition["Top"] = 1] = "Top";
    DialogPosition[DialogPosition["Bottom"] = 2] = "Bottom";
    DialogPosition[DialogPosition["Middle"] = 3] = "Middle";
    DialogPosition[DialogPosition["Full"] = 4] = "Full";
})(DialogPosition || (DialogPosition = {}));
//# sourceMappingURL=DialogPosition.js.map